import React, { useState } from "react";
import { DropzoneArea } from "material-ui-dropzone";
import { AttachFile, Audiotrack, Description, PictureAsPdf, Theaters, Image } from "@material-ui/icons";
import Input from "components/common_components/Input/Input";
import { sanitizeFileName } from "utils/files";
import { MenuItem, TextField } from "@material-ui/core";
import attachmentOrigins from "utils/static/attachmentOrigins";

const useFilesUploader = ({ requestOrigin = false }) => {
    const [filesToUpload, setFilesToUpload] = useState([]);
    const [fileNames, setFileNames] = useState({});
    const [fileOrigins, setFileOrigins] = useState({});

    const handleFileNameChange = (file, newName) => {
        setFileNames((prev) => ({
            ...prev,
            [file.name]: newName,
        }));
    };

    const handleFileOriginChange = (file, newOrigin) => {
        setFileOrigins((prev) => ({
            ...prev,
            [file.name]: newOrigin,
        }));
    };

    const handlePreviewIcon = (fileObject, classes) => {
        const { type } = fileObject.file;
        const iconProps = {
            className: classes.image,
        };

        const renderIcon = () => {
            if (type.startsWith("video/")) {
                return <Theaters {...iconProps} />;
            }
            if (type.startsWith("audio/")) {
                return <Audiotrack {...iconProps} />;
            }
            if (type.startsWith("image/")) {
                return <Image {...iconProps} />;
                // return <img src={fileObject.data} alt={fileObject.file.name} className={classes.image} />;
            }
            if (type === "application/pdf") {
                return <PictureAsPdf {...iconProps} />;
            }
            if (type.startsWith("text/")) {
                return <Description {...iconProps} />;
            }
            return <AttachFile {...iconProps} />;
        };

        return (
            <>
                {renderIcon()}
                <Input
                    value={fileNames[fileObject?.file?.name]}
                    onChange={(e) => handleFileNameChange(fileObject?.file, e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                />
                {requestOrigin && (
                    <TextField
                        className="form-item"
                        select
                        value={fileOrigins[fileObject?.file?.name]}
                        onChange={(e) => handleFileOriginChange(fileObject?.file, e.target.value)}
                        label="Origin"
                        size="small"
                        onMouseLeave={(e) => e.stopPropagation()}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {attachmentOrigins
                            .filter((origin) => !origin.excludeFromSelect)
                            .map((origin) => (
                                <MenuItem key={origin.value} value={origin.value} onClick={(e) => e.stopPropagation()}>
                                    {origin.label}
                                </MenuItem>
                            ))}
                    </TextField>
                )}
            </>
        );
    };

    return [
        filesToUpload,
        fileNames,
        fileOrigins,
        () => {
            setFilesToUpload([]);
            setFileNames({});
            setFileOrigins({});
        },
        ({ acceptedFiles = [FileTypes.PDF], filesLimit } = {}) => (
            <DropzoneArea
                onChange={(files) => {
                    setFilesToUpload(files);
                    setFileNames(
                        files.reduce((acc, file) => {
                            acc[file.name] = sanitizeFileName(file.name);
                            return acc;
                        }, {})
                    );
                }}
                maxFileSize={10490000} // 10MB
                filesLimit={filesLimit}
                acceptedFiles={acceptedFiles}
                getPreviewIcon={handlePreviewIcon}
                showFileNames
                showFileNamesInPreview
                clearOnUnmount
                previewGridClasses={{
                    container: "dropzone-preview-container",
                    item: "dropzone-preview-item",
                    image: "dropzone-preview-image",
                }}
                dropzoneText="Drag and drop a file here or click to select"
                classes={{
                    root: "dropzone-root",
                    text: "dropzone-text",
                    icon: "dropzone-icon",
                }}
            />
        ),
    ];
};

export default useFilesUploader;

export const FileTypes = {
    PDF: "application/pdf",
    IMAGE: "image/*",
    VIDEO: "video/*",
    AUDIO: "audio/*",
    TEXT: "text/*",
    ALL: "application/*",
};
